import { format } from "date-fns"
import { useTranslation } from "react-i18next"

import { CheckCircleIcon } from "@/components/icons"
import { Direction } from "@/generated/TradingGateway"
import { ExecutionTrade } from "@/services/executions"
import { formatNumber } from "@/utils"

import { useTileContext } from "../../TileContext"
import { OverlayBase, OverlayProps } from "./components"

const Stat = ({
  name,
  value,
  className,
}: {
  name: string
  value: string | number
  className: string
}) => {
  const { showingChart } = useTileContext()
  const direction = showingChart ? "flex-col" : "flex-row"
  const gap = showingChart ? "gap-xs" : "gap-sm"
  return (
    <div
      className={`flex flex-1 ${direction} bg-secondary px-md py-sm ${gap} ${className}`}
    >
      <p className="text-sm-regular leading-3 text-tertiary">{name}</p>
      <p className="flex-nowrap overflow-hidden text-sm-regular leading-3 text-ellipsis text-primary">
        {value}
      </p>
    </div>
  )
}

export const SuccessOverlay = ({
  trade,
  base,
  terms,
  onClose,
}: OverlayProps & { trade: ExecutionTrade }) => {
  const { t } = useTranslation()
  const { direction, notional, spotRate, valueDate, tradeId } = trade

  return (
    <OverlayBase
      className="bg-primary text-success-primary"
      base={base}
      terms={terms}
      tradeId={tradeId}
      onClose={onClose}
      Icon={<CheckCircleIcon />}
    >
      <div className="flex w-full flex-wrap gap-xs p-xs" role="alert">
        <div className="flex w-full justify-center gap-xs bg-success-primary py-xs">
          <p className="text-md-semibold text-primary">
            {t(
              direction === Direction.Buy
                ? "liveRates.executionResponse.success.bought"
                : "liveRates.executionResponse.success.sold",
            )}
          </p>
          <p className="text-md-semibold text-primary">
            {`${base} ${formatNumber(notional)}`}
          </p>
        </div>
        <Stat
          name={t("trade.cost")}
          value={`${terms} ${formatNumber(notional * spotRate)}`}
          className="flex-1"
        />
        <Stat name={t("trade.rate")} value={spotRate} className="flex-1" />
        <Stat
          name={t("trade.settlement")}
          value={`(Spt) ${format(valueDate, "dd MMM")}`}
          className="basis-full"
        />
      </div>
    </OverlayBase>
  )
}
